import { create } from 'zustand';

export type TDirtyState = {
  isDirty: boolean;
  setDirty: (isDirty: boolean) => void;
};

const dirtyStore = create<TDirtyState>((set) => ({
  isDirty: false,
  setDirty: (isDirty: boolean) => set({ isDirty }),
}));

export const useDirty = Object.assign(
  () => {
    const isDirty = dirtyStore((state) => state.isDirty);
    const setDirty = dirtyStore((state) => state.setDirty);
    return { isDirty, setDirty };
  },
  {
    getState: () => dirtyStore.getState(),
    setState: (state: Partial<TDirtyState>) => dirtyStore.setState(state),
    subscribe: (
      listener: (state: TDirtyState, prevState: TDirtyState) => void,
    ) => dirtyStore.subscribe(listener),
  },
);
